<template>
  <div class="home">
    <div class="menu-wrapper" >
      <div class="topTips">
        {{$t('topTips1')}} <span>{{$t('topTips2')}}</span>{{$t('topTips3')}}
      </div>
      <div class="menu" >
        <img src="@/assets/image/ec-logo.png" alt="">
        <ul class="language" >
          <li>
              <img src="@/assets/image/menu-language.png" alt="">
              <span class="language-content">{{$t('language')}}</span>
              <ul class="language-list">
                  <li @click="changeLang('zh')">中文简体</li>
                  <li @click="changeLang('en')">English</li>
              </ul>
          </li>
          <li style="padding-right:0" @click="logot">
              <img src="@/assets/image/menu-logot.png" alt="">
              <span class="logot" >{{$t('logot')}}</span>
          </li>
        </ul>
        <ul class="menu-list" v-if="userInfo.idCheckResultStatus == 2">
          <li v-for="(item,index) in menuList" :key="index">
            <span>
              {{$t(item.name)}}
            </span>
            <ol>
              <li v-for="(items,indexs) in item.children" >
                <router-link v-if="items.isPath" :to="items.path">{{$t(items.name)}}</router-link>
                <a v-if="!items.isPath" @click="openDialog(items.name)">{{$t(items.name)}}</a>
              </li>
            </ol>
          </li>
        </ul>
      </div>
    </div>
    <div class="content-wrapper">
      <router-view v-if="toggleFlag" class="content_height" />
      <footer-view ></footer-view>
    </div>
    
    <open-real :length="accounts.length" :open-dialog="isOpenReal"  @closeDialogReal="closeDialogReal"></open-real>
	  <modify-password ref="menu_my_modifypwd"></modify-password>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import { setup } from '@/langs'
import FooterView from '@/views/Footer.vue'
import OpenReal from '@/views/account/OpenReal.vue'
import RegisterDemo from '@/views/account/RegisterDemo.vue'
import ModifyPassword from '@/views/account/ModifyPassword.vue'


export default {
  name: 'Home',
  components: {
    OpenReal, RegisterDemo, ModifyPassword, FooterView
  },
  data(){
    return{
      menuList:[
        {
          name:'account',
          children:[
            {
              name:'myAccount',
              path:'/myAccount',
              isPath:true
            },
            {
              name:'rg_createreal',
              isPath:false
            },
            {
              name:'rg_registdemo',
              path:'/registerDemo',
              isPath:true
            },
            
            // {
            //   name:'menu_my_modifypwd',
            //   path:'/accountVerify',
            //   isPath:true
            // },
          ]
        },
        {
          name:'profile',
          children:[
           
            {
              name:'menu_my_modifypwd',
              path:'/ModifyPassword',
              isPath:false
            }
          ]
        },
        {
          name:'funds',
          children:[
             {
              name:'bankList',
              path:'/bankList',
              isPath:true
            },
            {
              name:'transferIn',
              path:'/transferIn',
              isPath:true
            },
            {
              name:'transferOut',
              path:'/transferOut',
              isPath:true
            },
            {
              name:'TransactionHistory',
              path:'/transferHistory',
              isPath:true
            }
          ]
        }
      ],
      toggleFlag:true,
      isOpenReal:false,
      accounts:[]
    }
  },
  computed: {
    ...mapState(['lang','userInfo'])
  },
  watch: {
    lang (lang) {
      this.toggleFlag= false
      //等v-if重载渲染后再把值赋值回来重新再渲染【关了界面再开。大家如果有更好的方法欢迎留言讨论】
      this.$nextTick(function () {
        this.toggleFlag = true
        location.reload()
      })
    }
  },
  created (){
    this.getAccounts()
  },
  methods: {
    changeLang(value){
        setup(value)
    },
    openDialog(name){
      if(name == 'rg_createreal'){
        this.isOpenReal = true
      }else{
        this.$refs[name].show()
      }
    },
    closeDialogReal(val){
      // console.log(val)
      this.isOpenReal = val
    },
    getAccounts(type){
      this.$axios.get('/api/MyAccount/Index',{
				params:{
					isReal:1
				}
			})
      .then(async (res) => {
				let dt = res.data
        if(dt.status == 1){
					this.accounts = dt.obj
        }else{
          this.$Message.error(dt.msg)
        }
      })
      .catch((err) => {
				this.loading = false
			})
    },
    logot(){
      this.$store.commit('logout')
      this.$router.push({ path:'/login'})
    }
  }
}
</script>
<style lang="less" scoped>
.home{
  width: 100%;
  height: 100%;
  .menu-wrapper{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100px;
    box-shadow: 0px 4px 14px 0px rgba(0,0,0,.1);
    z-index: 999;
    background: #ffffff;
    .menu{
      width: 1440px;
      margin: 0 auto;
      height: 100px;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      .menu-list{
        margin-left: 65px;
        height: 100px;
        line-height: 100px;
        display: flex;
        flex-direction: row;
        li{
          position: relative;
          font-size: 18px;
          color: #332c2b;
          padding: 0 20px;
          cursor: pointer;
          span{
            padding: 0 20px 25px 20px;
          }
          ol{
            position: absolute;
            top: 100px;
            background: #ffffff;
            min-width: 210px;
            left: 50%;
            margin-left: -100px;
            display: none;
            z-index: 999;
            li{
              font-size: 14px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              a{
                color: #001c38;
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            li:hover{
              background: #e32b3a;
              a{
                color: #fff;
              }
              
            }
          }
        }
      }
      .menu-list > li:hover span{
        color: #d12937;
        border-bottom: 3px solid #d02837;
      }
      .menu-list > li:hover ol{
        display: block;
      }
      .language{
            position: absolute;
            right: 0;
            top: 0;
            display: flex;
            flex-direction: row;
            li{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 100px;
                line-height: 100px;
                padding: 0 40px 0 14px;
                color:#332c2b;
                cursor: pointer;
                position: relative;
                img{
                    margin-right: 10px;
                }
                .language-content{
                    position: relative;
                }
                .language-list{
                    position: absolute;
                    top: 100px;
                    left: 0;
                    background: #ffffff;
                    width: 100%;
                    display: none;
                    box-shadow: 0px 0px 10px 0px rgba(0,0,0,.5);
                    z-index: 999;
                    li{
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        color: #332c2b;
                        height: 50px;
                        line-height: 50px;
                    }
                    li:hover{
                        color: #d12937;
                    }
                }
                .language-list::after{
                  content: "";
                  position: absolute;
                  right: 30px;
                  top: -12px;
                  width: 46px;
                  height: 12px;
                  background: url('../assets/image/triangle-white.png') no-repeat;
                }
            }
            li:hover ul{
                display: block;
            }
      }
    }
    .topTips{
      width: 1440px;
      margin: 20px auto;
      color: #8b8b8c;
      margin-bottom: 0;
      span{
        font-weight: 600;
      }
    }
  }
  .content-wrapper{
    padding-top: 180px;
    position: relative;
   
    .content_height{
       min-height: 440px;
    }
    // height: 100%;
    // height: 100%;
    // padding-bottom: 250px;
  }
}
</style>
